module.exports = __webpack_public_path__ + "img/icon-plane-blue.b48ed2f7.svg";